import { render } from "./EphemeridesHeader.vue?vue&type=template&id=1763de77"
import script from "./EphemeridesHeader.vue?vue&type=script&lang=js"
export * from "./EphemeridesHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__